import React from 'react';
import {
    Table,
    Row,
    Spin,
    Button, Popconfirm,
    Pagination,
} from 'antd';

import { asyncGet, actions, asyncGetallMonitorName, asyncGetTaskInfo ,delect} from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
import Edit from './edit.js';
import moment from 'moment';
import operationRecords from "./reducers";



class OperationRecords extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
        this.props.asyncGetallMonitorName();
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };
    /**
     * 分页器改变数据处理
     */
    handlePaginationChange = (current, pageSize) => {
        let pagination = {
            current,
            pageSize,
        };
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };

    edit = (record, type) => {
        this.props.editShow();
        this.props.changeCurrentSelectId(record.id);
      //  this.props.asyncGetTaskInfo(record, type);
    }

    handleDelete = async record => {
        record.deleteFlag = '1';
        await this.props.delect(record);
        this.props.asyncGet();
    }

    renderAction = (text, record) => {
        // console.log(expanded, record);
        return (
            <div>
                <Button type="primary" style={{ marginRight: '5px' }} size="small" onClick={() => {
                    this.edit(record);
                }}>
                    编辑
                </Button>
                <Popconfirm
                    title='确认删除'
                    okText='确定'
                    cancelText='取消'
                    onConfirm={() => {
                        this.handleDelete(record);
                    }}>
                    <Button type="danger" style={{ marginRight: '5px' }} size="small">
                        删除
                    </Button>
                </Popconfirm>
            </div>
        );
    };

    render() {
        let { list, uiStatus ,pagination} = this.props;
        let { isLoading } = uiStatus;
        const columns = [
            {
                title: '标题',
                dataIndex: 'title',
                key: 'title',
            },
            {
                title: '检测公司',
                dataIndex: 'monitorName',
                key: 'monitorName',
            },
            {
                title: '关联任务',
                dataIndex: 'concactTask',
                key: 'concactTask',
            },
            {
                title: '异常标签',
                dataIndex: 'erroTip',
                key: 'erroTip',
                render: (text, record, index) => {
                    if(text!=undefined && text!=null){
                        let result ="";
                        text.forEach(str=>{
                            if(result!="") {
                                result = result + "、" + str;
                            }else{
                                result+=str;
                            }
                        })
                        return result;
                    }
                    return "";
                },
            },
            {
                title: '异常摘要',
                dataIndex: 'erroMark',
                key: 'erroMark',
            },
            {
              title: '异常原因',
              dataIndex: 'erroReason',
              key: 'erroReason',
            },
            {
                title: '解决办法',
                dataIndex: 'resolvent',
                key: 'resolvent',
            },
            {
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                render: (text, record, index) => {
                    return this.renderAction(text, record, index);
                },
            }
        ];
        let { totalPage, current, pageSize } = pagination;
        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                    <Table
                        columns={columns}
                        dataSource={list}
                        pagination={false}
                    />
                     <Row type="flex" justify="end">
                        <Pagination
                            style={{ padding: '10px 10px' }}
                            size="small"
                            showQuickJumper
                            pageSize={pageSize}
                            current={current}
                            total={totalPage}
                            showTotal={(total, range) =>
                                `共 ${total ? total : '0'} 条记录，每页 ${pageSize} 条，这是第 ${totalPage
                                    ? current + '/' + totalPage
                                    : '1'} 页`}
                            showSizeChanger
                            pageSizeOptions={['10', '15', '20', '40']}
                            onShowSizeChange={this.handlePaginationChange}
                            onChange={this.handlePaginationChange}
                        />
                    </Row>
                    <Edit />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    list: state.operationRecords.list,
    pagination: state.operationRecords.pagination,
    proxyrepeatinfo: state.operationRecords.proxyrepeatinfo,
    uiStatus: state.operationRecords.uiStatus,
    agentsGroup: state.operationRecords.agentsGroup,
    transferData: state.operationRecords.transferData,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    asyncGetTaskInfo: (record, type) => dispatch(asyncGetTaskInfo(record, type)),
    asyncGetallMonitorName: () => dispatch(asyncGetallMonitorName()),
    changePagination: data => dispatch(actions.changePagination(data)),
    changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    delect: record => dispatch(delect(record)),
});
export default connect(mapStateToProps, mapDispatchToProps)(OperationRecords);






// WEBPACK FOOTER //
// ./pages/sign/operationRecords/index.js